import React, { useState, useEffect, useRef } from 'react';
import Btn from '../../../../Components/Btn';
import { Panel, PanelHeader, PanelBody, PanelSection } from '../../../../Components/Panel/Panel';
import SearchBar from '../../../../Components/SearchBar';
import Confirm from '../../../../Components/Confirm';
import { EmptyState } from '../../../../Components/EmptyState/EmptyState';
import { useRankingContext } from '../../Ranking/context/RankingContextProvider';
import { replaceId, demoteId, promoteId, pinId } from '../../Ranking/utils';
import SearchProducts from '../SearchProducts';
import { TabManualSorting } from '../TabManualSorting';
import DraggableContainer from './DraggableProducts';
import { SwapList } from './SwapList';
import TabPromote from './PanelManualSortingBody';
import ShopifyManualSortingPanel from './ShopifySorting/ShopifyManualSortingPanel';
import ShopifyCollectionPinnedProductsService from '../../Ranking/services/ShopifyCollectionPinnedProductsService';
import { PinnedShopifyProduct, ShopifyCollectionWithPinnedProducts } from './ShopifySorting/ShopifyManualSortingTypes';

export default function PanelManualSorting({
	dimension,
	handleClose = () => { undefined; },
	panelIsOpen,
	activeTab,
	setActiveTab
}) {

	const {
		rankingObject,
		applyManualTransformations,
		//previewTenant,
		//accountId,
		setModalManualIsOpen,
		needToLoadPromote,
		setNeedToLoadPromote,
		needToLoadDemote,
		setNeedToLoadDemote,
		localArrayOfProductIdSwap: localSwapProductIds,
		setLocalArrayOfProductIdSwap,
		canUseShopifyManualSorting,
		shopifyCollectionWithPinnedProducts,
		shopifyCollectionPinnedProductsService,
		typeCategoriesSecondLevelSelected,
		selectedCategoryIsShopifyCollection,
		hasRetrievedNoShopifyCollection,
		shopifyCollections,
		searchProductsByIds,
		searchProductsByTerm,
		searchProducts,
		changeSecondCategorySelected,
		handleSelectCategorySelection
	} = useRankingContext();

	const [openCancelPopin, setOpenCancelPopin] = useState(false);
	const [localPromoteProductIds, setLocalArrayOfProductIdPromote] = useState<any[]>([]);
	const [localDemoteProductIds, setLocalArrayOfProductIdDemote] = useState<any[]>([]);
	const [promotedProducts, setArrayOfPromoteWithDataProducts] = useState<any[]>([]);
	const [demotedProducts, setArrayOfDemoteWithDataProducts] = useState<any[]>([]);
	const initialPromoteIds = useRef<any[]>([]);
	const initialDemoteIds = useRef<any[]>([]);
	const initialSwapIds = useRef<any[]>([]);
	const initialShopifyManualPositions = useRef<ShopifyCollectionWithPinnedProducts[] | undefined>(undefined);

	const [searchTerm, setSearchTerm] = useState('');
	const [searchTermForInput, setSearchTermForInput] = useState('');

	const [localShopifyCollectionWithPinnedProducts, setLocalShopifyCollectionWithPinnedProducts] = useState<ShopifyCollectionWithPinnedProducts[] | undefined>(shopifyCollectionWithPinnedProducts);
	const localShopifyCollectionPinnedProductsService = ShopifyCollectionPinnedProductsService(setLocalShopifyCollectionWithPinnedProducts);

	useEffect(() => {
		const searchTimeout = setTimeout(() => {
			setSearchTerm(searchTermForInput);
		}, 500);

		return () => {
			clearTimeout(searchTimeout);
		};
	}, [searchTermForInput]);

	const confirmClose = () => {
		handleClose();
		setNeedToLoadPromote(true);
		setNeedToLoadDemote(true);
	};

	const handleClosePanel = () => {
		const hasUnsavedChanges =
			JSON.stringify(localPromoteProductIds) !== JSON.stringify(initialPromoteIds.current) ||
			JSON.stringify(localDemoteProductIds) !== JSON.stringify(initialDemoteIds.current) ||
			JSON.stringify(localSwapProductIds) !== JSON.stringify(initialSwapIds.current) ||
			JSON.stringify(localShopifyCollectionWithPinnedProducts) !== JSON.stringify(initialShopifyManualPositions.current)
			;
		if (hasUnsavedChanges) {
			setOpenCancelPopin(true);
		} else {
			confirmClose();
		}
	};

	const filterBySign = (arrayToFilter, idToFilter) => {
		const itemToTransform = arrayToFilter.filter((el) => el.collationId === idToFilter);
		let elementsToReturn = [] as any[];
		if (itemToTransform.length !== 0) {
			elementsToReturn = [...itemToTransform[0]['params'][0]['value']['stringValues']];
		}
		return elementsToReturn;
	};

	const getReplacesObj = (arrayToFilter) => {
		const uniqueItem = arrayToFilter.reduce((acc, curr) => {
			if (curr.collationId === replaceId) {
				const newObj = {
					...curr,
					idOld: curr.params.find((el) => el.name === 'First Product Id').value.stringValues,
					idReplace: curr.params.find((el) => el.name === 'Second Product Id').value.stringValues,
				};
				acc = [...acc, newObj];
			}
			return acc;
		}, []);
		return [...new Set(uniqueItem)];
	};

	useEffect(() => {
		const newObjectOfPromoted = filterBySign(rankingObject.transformations, promoteId);
		setLocalArrayOfProductIdPromote(newObjectOfPromoted);
		initialPromoteIds.current = newObjectOfPromoted;

		const newObjectOfDemoted = filterBySign(rankingObject.transformations, demoteId);
		setLocalArrayOfProductIdDemote(newObjectOfDemoted);
		initialDemoteIds.current = newObjectOfDemoted;

		const newPIds = getReplacesObj(rankingObject.transformations);
		setLocalArrayOfProductIdSwap(newPIds);
		initialSwapIds.current = newPIds;
	}, [rankingObject?.transformations]);

	useEffect(() => {
		setLocalShopifyCollectionWithPinnedProducts(shopifyCollectionWithPinnedProducts);
		initialShopifyManualPositions.current = shopifyCollectionWithPinnedProducts;
	}, [shopifyCollectionWithPinnedProducts]);

	const deleteProduct = (idOfProduct) => {
		function flattenArray(arr) {
			return arr.reduce((acc, item) => {
				if (typeof item === 'string') {
					acc.push(item);
				} else if (typeof item === 'object' && item !== null) {
					if (item.id) {
						acc.push(item.id);
					} else if (item.name) {
						acc.push(item.name);
					}
				}
				return acc;
			}, []);
		}

		if (dimension === replaceId) {
			const newArray = localSwapProductIds.filter((el) => el.idOld[0] !== idOfProduct);
			setLocalArrayOfProductIdSwap(newArray);
		} else if (dimension === promoteId) {
			const newArray = flattenArray(localPromoteProductIds).filter((el) => el !== idOfProduct);
			setLocalArrayOfProductIdPromote(newArray);
			setArrayOfPromoteWithDataProducts((prevArray) => prevArray.filter((el) => el.id !== idOfProduct));
		} else if (dimension === demoteId) {
			const newArray = flattenArray(localDemoteProductIds).filter((el) => el !== idOfProduct);
			setLocalArrayOfProductIdDemote(newArray);
			setArrayOfDemoteWithDataProducts((prevArray) => prevArray.filter((el) => el.id !== idOfProduct));
		}
	};

	const deleteProductAll = () => {
		if (dimension === replaceId) {
			setLocalArrayOfProductIdSwap([]);
		} else if (dimension === promoteId) {
			setLocalArrayOfProductIdPromote([]);
			setArrayOfPromoteWithDataProducts([]);
		} else if (dimension === demoteId) {
			setLocalArrayOfProductIdDemote([]);
			setArrayOfDemoteWithDataProducts([]);
		}
	};

	const addProduct = (productId) => {
		if (dimension === promoteId) {
			setNeedToLoadPromote(true);
			setLocalArrayOfProductIdPromote((prevArray) => [...prevArray, productId]);
		} else if (dimension === demoteId) {
			setNeedToLoadDemote(true);
			setLocalArrayOfProductIdDemote((prevArray) => [...prevArray, productId]);
		} else if (dimension === replaceId) {
			setLocalArrayOfProductIdSwap((prevArray) => [...prevArray, productId]);
		}
	};

	const handleValidateSave = () => {
		applyManualTransformations(
			localPromoteProductIds,
			localDemoteProductIds,
			localSwapProductIds);

		shopifyCollectionPinnedProductsService.handleSetAll(localShopifyCollectionWithPinnedProducts);
		confirmClose();
	};

	// const validDeletingAction = () => {
	// 	deleteProductsMultiDimension(
	// 		localArrayOfProductIdPromote,
	// 		localArrayOfProductIdDemote,
	// 		localArrayOfProductIdSwap);
		
	// 	handleClose();
	// 	setNeedToLoadPromote(true);
	// 	setNeedToLoadDemote(true);
	// };
	
	const handleChangeDimension = (d) => {
		setActiveTab(d);
		setSearchTerm('');
		setSearchTermForInput('');
	};

	const handleOnDragEnd = (newItems) => {
		const ids = newItems.map(x => x.id);
		if (dimension === promoteId) {
			setLocalArrayOfProductIdPromote(ids);
		} else {
			setLocalArrayOfProductIdDemote(ids);
		}
	};

	const hasCollisionWithTransformations = (item: PinnedShopifyProduct): { hasEror: boolean, message?: string | null }[] => {
		const swapped = localSwapProductIds.find(x => x.idOld === item.product.id || x.idReplace === item.product.id);

		const d = localDemoteProductIds.includes(item.product.id) ? [{ hasEror: true, message: 'This product is a demoted product.' }] : [];
		const p = localPromoteProductIds.includes(item.product.id) ? [{ hasEror: true, message: 'This product is a promoted product.' }] : [];
		const r = swapped !== undefined ? [{ hasEror: true, message: `This product swapped with another product: ${swapped.idOld === item.product.id ? swapped.idOld : swapped.idReplace}.` }] : [];

		const errors = [...d, ...p, ...r];
		return errors;
	};

	return (
		<Panel isOpen={panelIsOpen} width={760}>
			<Confirm
				isOpen={openCancelPopin}
				title='Some changes are not saved'
				text='Are you sure you want to close the "Manual sorting" panel without saving?'
				cancelText="Stay"
				confirmText="Close without saving"
				confirmColor='alert'
				confirmCallback={() => confirmClose()}
				onClose={() => setOpenCancelPopin(false)}
			/>
			<PanelHeader
				title={'Manual sorting'}
				hasClose={true}
				onClose={handleClosePanel}
				primaryAction={
					<Btn
						onClick={() => handleValidateSave()}
						message="Save"
						color="primary"
					/>
				}
				tabs={
					<TabManualSorting
						activeTab={activeTab}
						setActiveTab={handleChangeDimension}
						showPinManualSortingTab={canUseShopifyManualSorting}
						canUseShopifyManualSorting={canUseShopifyManualSorting}
					/>
				}
			/>

			{(dimension === promoteId || dimension === demoteId) &&
				<TabPromote
					searchTerm={searchTerm}
					searchTermForInput={searchTermForInput}
					handleSearch={(v) => setSearchTermForInput(v)}
					handleAdd={() => setModalManualIsOpen(true)}
					handleDeleteAll={deleteProductAll}
					nbProducts={dimension === promoteId ? localPromoteProductIds?.length : localDemoteProductIds?.length}
					dimension={dimension}
					productList={
						<>
							{(dimension === promoteId && localPromoteProductIds?.length > 0) && (
								<DraggableContainer
									dimension={dimension}
									elementToMap={localPromoteProductIds.map((product) => ({ id: product, name: product }))}
									handleOnDragEnd={handleOnDragEnd}
									onDelete={deleteProduct}
									setNeedToReload={setNeedToLoadPromote}
									needToReload={needToLoadPromote}
									items={promotedProducts}
									setItems={setArrayOfPromoteWithDataProducts}
									searchTerm={searchTerm}
									searchProductsByIds={searchProductsByIds}
									changeSecondCategorySelected={changeSecondCategorySelected}
									handleSelectCategorySelection={(c) => {handleSelectCategorySelection(c); handleClosePanel();}}
								/>
							)}
							{(dimension === demoteId && localDemoteProductIds?.length > 0) && (
								<DraggableContainer
									dimension={dimension}
									elementToMap={localDemoteProductIds.map((product) => ({ id: product, name: product }))}
									handleOnDragEnd={handleOnDragEnd}
									onDelete={deleteProduct}
									setNeedToReload={setNeedToLoadDemote}
									needToReload={needToLoadDemote}
									items={demotedProducts}
									setItems={setArrayOfDemoteWithDataProducts}
									searchTerm={searchTerm}
									searchProductsByIds={searchProductsByIds}
									changeSecondCategorySelected={changeSecondCategorySelected}
									handleSelectCategorySelection={(c) => {handleSelectCategorySelection(c); handleClosePanel();}}
								/>
							)}
							<SearchProducts
								dimension={dimension}
								onAddProduct={addProduct}
								searchTerm={searchTerm}
								searchProductsByTerm={(s, e) => searchProductsByTerm(searchTerm, s, e)}
								arrayOfIdsToExcludes={dimension === promoteId ? localPromoteProductIds : localDemoteProductIds}
								allProduct={false}
								deleteList={undefined}
							/>
						</>
					}
				/>
			}
			{dimension === replaceId && (
				<>
					{(!localSwapProductIds || localSwapProductIds.length === 0) ?
						<PanelBody position='relative'>
							<EmptyState
								title={'Manually swap products in the ranking'}
								verticalAlign={true}
								primaryAction={
									<Btn
										onClick={() => setModalManualIsOpen(true)}
										icon="fas fa-plus-circle"
										message="Swap products"
										color="primary"
										style='reverse'
									/>
								}
							/>
						</PanelBody>
						:
						<>
							<PanelSection hasBottomBorder={false}>
								<div className='flex'>
									<div className='flex_item_full'>
										<SearchBar
											value={searchTermForInput}
											onChange={(v) => setSearchTermForInput(v)}
											placeholder={'Search for a swapped product'}
											fullWidth={false}
											width="l"
										/>
									</div>
									<div className='flex_item_fix ml_20'>
										<Btn
											onClick={() => setModalManualIsOpen(true)}
											icon="fas fa-plus-circle"
											message="Swap products"
											color="primary"
											style='reverse'
										/>
										<Btn
											onClick={() => deleteProductAll()}
											tooltip="Remove all swaped"
											color="secondary"
											style="outline"
											icon="fas fa-ban"
											horizontalSize="xxs"
										/>
									</div>
								</div>
							</PanelSection>
							<PanelBody hasTopMargin={false}>
								{(dimension === replaceId && localSwapProductIds?.length > 0) && (
									<SwapList
										elementToMap={localSwapProductIds}
										searchTerm={searchTerm}
										searchProductsByIds={searchProductsByIds}
										deleteProduct={deleteProduct}
									/>
								)}
							</PanelBody>
						</>
					}
				</>
			)}
			{dimension === pinId && canUseShopifyManualSorting &&
				<ShopifyManualSortingPanel
					shopifyCollectionWithPinnedProducts={localShopifyCollectionWithPinnedProducts}
					shopifyCollectionPinnedProductsService={localShopifyCollectionPinnedProductsService}
					typeCategoriesSecondLevelSelected={typeCategoriesSecondLevelSelected}
					selectedCategoryIsShopifyCollection={selectedCategoryIsShopifyCollection}
					searchProducts={searchProducts}
					searchProductsByTerm={(s, e) => searchProducts({
						searchTerm: searchTerm,
						limit: 40
					}, s, e)}
					searchTerm={searchTerm}
					searchTermForInput={searchTermForInput}
					handleAutocompleteChange={(v) => setSearchTermForInput(v)}
					shopifyCollections={shopifyCollections}
					hasRetrievedNoShopifyCollection={hasRetrievedNoShopifyCollection}
					hasCollisionWithTransformations={hasCollisionWithTransformations}
				/>
			}
		</Panel>
	);
}
